module.exports = __webpack_public_path__ + "img/404.39f48f9b.png";